export const GET_TYPE = "GET_TYPE";
export const GET_FILTER = "GET_FILTER";
export const CLEAR_FILTER = "CLEAR_FILTER";



// WEBPACK FOOTER //
// ./src/modules/search/actionTypes.js